import { render, staticRenderFns } from "./UniqueCustomers.vue?vue&type=template&id=34c26f0c&lang=pug"
import script from "./UniqueCustomers.vue?vue&type=script&lang=js"
export * from "./UniqueCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports